module.exports = __webpack_public_path__ + "static/media/manmohan.c17a8add.jpeg";